/**
 * Colonnes du fichier d'import des fiches collaborateurs : mêmes colonnes que le fichier paie
 * fourni, plus « Date fin contrat » en fin. Clé de schéma backend → libellé d'en-tête. Le modèle
 * du back-office écrit ces libellés dans cet ordre, le backend résout les colonnes par leur nom.
 */
export const COLLABORATOR_IMPORT_HEADERS = {
  codeMatricule: 'Code matricule',
  matricule: 'Matricule',
  nom: 'Nom',
  prenom: 'Prénom',
  services: 'Service(s)',
  dateDebutServices: 'Date début Service(s)',
  contratHoraire: 'Contrat horaire',
  dateDebutContratHoraire: 'Date début contrat horaire',
  baseHoraire: 'Base horaire',
  repartitionBaseHoraire: 'Répartition base horaire',
  typeBaseHoraire: 'Type de base horaire',
  dateDebutDureeTravail: 'Date début durée du travail',
  dateFinContrat: 'Date fin contrat',
} as const

export type CollaboratorImportHeaderKey = keyof typeof COLLABORATOR_IMPORT_HEADERS
